// eslint-disable-next-line no-unused-vars
import utils from "@/system/utils";
// eslint-disable-next-line no-unused-vars
import {
  emotionsBySession,
  participationsBySession,
  attentionsBySession,
  participantsBySession,
} from "@/system/mockData";
import { BASE_URL, IS_LOCAL_MODE } from "@/system/config";
import {
  AttentionEvent,
  EmotionsEvent,
  Participant,
  ParticipationEvent,
  Session,
  SessionApi,
} from "@/services/typescript-fetch-client-generated";

export interface AttentionEventEx extends AttentionEvent {
  ts: number;
}

export interface EmotionsEventEx extends EmotionsEvent {
  ts: number;
}

export interface ParticipantEx extends Participant {
  show: boolean;
}

export interface ParticipationEventEx extends ParticipationEvent {
  ts: number;
}

export default {
  api(): SessionApi {
    return new SessionApi(
      { username: "moodmedemo", password: "moodme" },
      BASE_URL
    );
  },

  async getSessionParticipants(sessionId: number) {
    return (await this.api().getSessionParticipants(sessionId)).data || [];
  },

  async getSessionEmotions(sessionId: number) {
    return (await this.api().getSessionEmotionEvents(sessionId)).data || [];
  },

  async getSessionAttentions(sessionId: number) {
    return (await this.api().getSessionAttentionEvents(sessionId)).data || [];
  },

  async getSessionParticipations(sessionId: number) {
    return (
      (await this.api().getSessionParticipationEvents(sessionId)).data || []
    );
  },

  async getAllSessions(): Promise<Session[]> {
    return (await this.api().getSessions()).data || [];

    // if (!IS_LOCAL_MODE) return (await this.api().getSessions()).data || [];
    // await utils.promiseTimeout(500);
    // return mockSessions;
  },

  async getSessionData(sessionId: number): Promise<{
    participations: ParticipationEventEx[];
    emotions: EmotionsEventEx[];
    attentions: AttentionEventEx[];
    participants: ParticipantEx[];
  }> {
    if (IS_LOCAL_MODE) await utils.promiseTimeout(2000);

    let participations: ParticipationEvent[] = [];
    if (IS_LOCAL_MODE) {
      if (participationsBySession[sessionId])
        participations = participationsBySession[sessionId].data || [];
    } else participations = await this.getSessionParticipations(sessionId);

    let participants: Participant[] = [];
    if (IS_LOCAL_MODE) {
      if (participantsBySession[sessionId])
        participants = participantsBySession[sessionId].data || [];
    } else {
      participants = await this.getSessionParticipants(sessionId);
    }
    // update participant css-class for colored frame
    participants.map(
      (p: any, key: number) => (p.colorClass = "avatar-color-" + key)
    );

    let attentions: AttentionEvent[] = [];
    if (IS_LOCAL_MODE) {
      if (attentionsBySession[sessionId])
        attentions = attentionsBySession[sessionId].data || [];
    } else {
      attentions = await this.getSessionAttentions(sessionId);
    }

    let emotions: EmotionsEvent[] = [];
    if (IS_LOCAL_MODE) {
      if (emotionsBySession[sessionId])
        emotions = emotionsBySession[sessionId].data || [];
    } else {
      emotions = await this.getSessionEmotions(sessionId);
    }

    const participationEx: ParticipationEventEx[] = participations.map(
      (value) => {
        return value as ParticipationEventEx;
      }
    );

    const attentionsEx: AttentionEventEx[] = attentions.map((value) => {
      return value as AttentionEventEx;
    });

    const participantsEx: ParticipantEx[] = participants.map((value) => {
      return value as ParticipantEx;
    });

    const emotionsEx: EmotionsEventEx[] = emotions.map((value) => {
      return value as EmotionsEventEx;
    });

    return {
      participations: participationEx,
      attentions: attentionsEx,
      participants: participantsEx,
      emotions: emotionsEx,
    };
  },
};
